// extracted by mini-css-extract-plugin
export var calories = "LPJYU";
export var column = "mnszL";
export var image = "Bs6LO";
export var info = "tbmws";
export var ingredient = "tXJIA";
export var ingredientsList = "cOHGT";
export var ingredientsTitle = "RuBEZ";
export var instruction = "L-B-p";
export var instructionsList = "WbesS";
export var instructionsTitle = "_7R3KW";
export var preparationTimeMin = "_9WSQO";
export var recipe = "qywXE";
export var title = "fdFES";